import {ButtonGroup} from "@atlaskit/button";
import type {ComponentProps} from "react";

export function AnankeButtonGroup(props: ComponentProps<typeof ButtonGroup>) {
    return <ButtonGroup {...props} />;
}
